import { useGetUserInfo } from "api/api-hooks/user-hooks";
import {
  IUserStatisticsComponentProps,
  preProcessJobData,
  preProcessUserData,
  ProcessedJobData,
  ProcessedUserData,
  secondsToHm,
} from "components/pages/users-statistics-dashboard/stats-utils";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import { T } from "services/lang/LanguageService";

function UserStatisticsDatatable({
  userSessionData,
  groupBy,
  jobTitleFilter,
}: IUserStatisticsComponentProps) {
  const [userTableData, setUserTableData] = useState<ProcessedUserData[]>();
  const [jobTableData, setJobTableData] = useState<ProcessedJobData[]>();

  useEffect(() => {
    setUserTableData(preProcessUserData(userSessionData));
  }, [userSessionData, jobTitleFilter]);

  useEffect(() => {
    setJobTableData(preProcessJobData(userTableData, groupBy, jobTitleFilter));
  }, [userTableData, groupBy, jobTitleFilter]);

  const totalTimeBodyTemplate = (rowData: any) => {
    return secondsToHm(rowData.totalSessionTime);
  };
  const userBodyTemplate = (rowData: any) => {
    const userInfo = useGetUserInfo(rowData.user);
    return userInfo.data?.displayName;
  };
  const averageTimeBodyTemplate = (rowData: any) => {
    return secondsToHm(rowData.averageSessionDuration);
  };

  const isGroupedByJob = groupBy === "jobTitle";

  return (
    <div className="mt-2">
      <DataTable
        value={isGroupedByJob ? jobTableData : userTableData}
        removableSort
        size="small"
        scrollable
        scrollHeight="350px"
      >
        {!isGroupedByJob && <Column field="user" header={T("word.user")} body={userBodyTemplate} />}
        <Column field="jobTitle" header={T("label.job-title")} />
        <Column
          field="totalSessionTime"
          header={T("label.total-time-logged-in")}
          body={totalTimeBodyTemplate}
          sortable
        />
        <Column
          field="averageSessionDuration"
          header={T("label.averarge-time-logged-in")}
          body={averageTimeBodyTemplate}
          sortable
        />
        <Column field="totalSessions" header={T("label.login-count")} sortable />
        <Column field="activeDaysCount" header={T("label.active-days")} sortable />
      </DataTable>
    </div>
  );
}

export default UserStatisticsDatatable;
